import React from 'react'

import ModalLayout from '@/app/component/layout/modal'

import CreateGroupForm from './form/create-group-form'

type Props = {
  open: boolean
  onClose: () => void
}

const CreateGroupDialog: React.FC<Props> = ({ open, onClose }) => (
  <ModalLayout title="Add group" isOpen={open} onClose={onClose}>
    <CreateGroupForm onExit={onClose} />
  </ModalLayout>
)

export default CreateGroupDialog
